import axios from 'axios'

// 记录当前配置状态
let isWxConfigured = false;
let isWxConfiguring = false;
let lastShareData = null;
let wxReadyCallbacks = [];
let currentSignUrl = ''; // 当前用于签名的URL
let wxJsLoaded = false; // 微信JS是否已加载
let retryCount = 0; // 重试计数器
const MAX_RETRY = 3; // 最大重试次数

// 微信JSSDK配置
const wxConfig = {
  // debug: true,
  jsApiList: [
    'updateAppMessageShareData',
    'updateTimelineShareData',
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'previewImage',
    'checkJsApi'
  ]
}

// 清理URL，获取用于签名的URL
const getCleanUrl = () => {
  let url = window.location.href;
  // 移除hash
  url = url.split('#')[0]; // 对于 'https://domain.com/#/path?query' 会变成 'https://domain.com/'
  console.log('获取用于签名的URL (包含查询参数，不含hash):', url);
  return url;
}

// 动态加载微信JS SDK
const loadWxJs = () => {
  return new Promise((resolve, reject) => {
    if (typeof wx !== 'undefined' && wx.ready) {
      wxJsLoaded = true;
      return resolve(true);
    }
    
    // 由于JS-SDK已在index.html中同步加载，这里只需要等待wx.ready就绪
    const checkReady = setInterval(() => {
      if (typeof wx !== 'undefined' && wx.ready) {
        clearInterval(checkReady);
        wxJsLoaded = true;
        resolve(true);
      }
    }, 100);
    
    // 5秒后仍未就绪则超时
    setTimeout(() => {
      clearInterval(checkReady);
      reject(new Error('微信JS SDK就绪超时'));
    }, 5000);
  });
};

// 获取微信配置（从后端接口）
const getWxConfig = async (forceRefresh = false) => {
  try {
    // 获取用于签名的干净URL
    const cleanUrl = getCleanUrl();
    
    // 如果URL没变且不强制刷新，避免重复请求
    if (cleanUrl === currentSignUrl && !forceRefresh) {
      console.log('URL未变化，使用已有配置');
      return null;
    }
    
    // 更新当前签名URL
    currentSignUrl = cleanUrl;
    
    // 添加随机参数，避免微信缓存
    const timestamp = Date.now();
    const randomStr = Math.random().toString(36).substring(2, 8);
    
    console.log('请求微信配置，URL:', cleanUrl);
    
    // 向后端发送请求
    const response = await axios.get('/api/wx/jsconfig', {
      params: {
        url: cleanUrl,
        t: timestamp,
        r: randomStr
      },
      timeout: 10000 // 设置10秒超时
    });
    
    // 检查接口返回状态
    if (response.data.code === 200) {
      console.log('获取微信配置成功:', response.data.data);
      retryCount = 0; // 重置重试计数
      return response.data.data;
    } else {
      console.error('获取微信配置失败:', response.data.msg);
      throw new Error(response.data.msg || '获取微信配置失败');
    }
  } catch (error) {
    console.error('获取微信配置失败:', error);
    
    // 重试机制
    if (retryCount < MAX_RETRY) {
      retryCount++;
      console.log(`获取配置失败，第${retryCount}次重试...`);
      // 延迟重试，每次延迟时间递增
      await new Promise(resolve => setTimeout(resolve, retryCount * 1000));
      return getWxConfig(forceRefresh);
    }
    
    throw error;
  }
}

// 配置微信分享内容
const configWxShareContent = (shareData) => {
  if (!shareData) {
    console.error('分享数据为空');
    return;
  }

  let finalImgUrl = shareData.imgUrl;
  const newDefaultImgUrl = 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/logo.jpg';
  if (finalImgUrl && (finalImgUrl.startsWith('.') || !(finalImgUrl.startsWith('http://') || finalImgUrl.startsWith('https://')))) {
    finalImgUrl = newDefaultImgUrl;
  } else if (!finalImgUrl) {
    finalImgUrl = newDefaultImgUrl;
  }
  
  const validShareData = {
    title: shareData.title || '科普视频分享',
    desc: shareData.desc || '来自BAHIM科普部的精彩视频',
    link: shareData.link || getCleanUrl(),
    imgUrl: finalImgUrl,
    type: 'link',
    dataUrl: shareData.videoUrl || ''
  };

  console.log('配置分享内容:', validShareData);
  lastShareData = validShareData;

  if (typeof wx === 'undefined' || !wxJsLoaded) {
    console.error('微信JS SDK未加载或未就绪，无法配置分享内容');
    return;
  }

  // 检查API支持情况后再调用
  wx.checkJsApi({
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'],
    success: function(res) {
      console.log('checkJsApi result:', res);

      // 配置分享给朋友 (优先新接口)
      if (res.checkResult.updateAppMessageShareData) {
        console.log('使用新版分享接口：updateAppMessageShareData');
        wx.updateAppMessageShareData({
          title: validShareData.title,
          desc: validShareData.desc,
          link: validShareData.link,
          imgUrl: validShareData.imgUrl,
          success: () => console.log('新版-分享给朋友成功'),
          fail: (err) => console.error('新版-分享给朋友失败:', err)
        });
      } else if (res.checkResult.onMenuShareAppMessage) {
        console.log('使用旧版分享接口：onMenuShareAppMessage');
        wx.onMenuShareAppMessage({
          title: validShareData.title,
          desc: validShareData.desc,
          link: validShareData.link,
          imgUrl: validShareData.imgUrl,
          type: 'link',
          success: () => console.log('旧版-分享给朋友成功'),
          cancel: () => console.log('旧版-取消分享给朋友')
        });
      } else {
        console.warn('没有可用的"分享给朋友"接口');
      }

      // 配置分享到朋友圈 (优先新接口)
      if (res.checkResult.updateTimelineShareData) {
        console.log('使用新版分享接口：updateTimelineShareData');
        wx.updateTimelineShareData({
          title: validShareData.title,
          link: validShareData.link,
          imgUrl: validShareData.imgUrl,
          success: () => console.log('新版-分享到朋友圈成功'),
          fail: (err) => console.error('新版-分享到朋友圈失败:', err)
        });
      } else if (res.checkResult.onMenuShareTimeline) {
        console.log('使用旧版分享接口：onMenuShareTimeline');
        wx.onMenuShareTimeline({
          title: validShareData.title,
          link: validShareData.link,
          imgUrl: validShareData.imgUrl,
          success: () => console.log('旧版-分享到朋友圈成功'),
          cancel: () => console.log('旧版-取消分享到朋友圈')
        });
      } else {
        console.warn('没有可用的"分享到朋友圈"接口');
      }
    },
    fail: function(err) {
      console.error('wx.checkJsApi失败:', err);
      // 即使checkJsApi失败，也尝试使用新接口进行配置，作为降级策略
      // 因为日志显示updateAppMessageShareData是true，但可能checkJsApi本身出了点小问题
      console.log('checkJsApi失败，尝试直接调用新版分享接口作为降级');
      wx.updateAppMessageShareData({
        title: validShareData.title,
        desc: validShareData.desc,
        link: validShareData.link,
        imgUrl: validShareData.imgUrl,
        success: () => console.log('降级-分享给朋友成功'),
        fail: (e) => console.error('降级-分享给朋友失败:', e)
      });
      // 对于朋友圈，由于日志显示不支持，这里就不再尝试了
    }
  });
};

// 检查是否支持所需的JS接口
const checkJsApi = () => {
  if (typeof wx === 'undefined' || typeof wx.checkJsApi !== 'function') {
    return Promise.resolve(false);
  }
  
  return new Promise((resolve) => {
    wx.checkJsApi({
      jsApiList: wxConfig.jsApiList,
      success: (res) => {
        console.log('JS API检查结果:', res);
        resolve(true);
      },
      fail: (res) => {
        console.error('JS API检查失败:', res);
        resolve(false);
      }
    });
  });
};

// 初始化微信分享 - 返回Promise以便等待完成
export const initWxShare = async (shareData, forceRefresh = false) => {
  return new Promise(async (resolve, reject) => {
    try {
      // 确保是在微信浏览器中
      if (!isWeixinBrowser()) {
        console.log('非微信浏览器，不初始化分享');
        resolve(false);
        return;
      }
      
      console.log('初始化微信分享, 强制刷新:', forceRefresh);
      
      // 确保微信JS SDK已完全加载和就绪
      try {
        await loadWxJs();
        // 等待wx.ready就绪
        await new Promise((resolve) => {
          if (typeof wx !== 'undefined' && wx.ready) {
            resolve();
          } else {
            const checkReady = setInterval(() => {
              if (typeof wx !== 'undefined' && wx.ready) {
                clearInterval(checkReady);
                resolve();
              }
            }, 100);
            
            setTimeout(() => {
              clearInterval(checkReady);
              resolve(); // 超时后也继续执行
            }, 5000);
          }
        });
      } catch (error) {
        console.error('加载微信JS SDK失败:', error);
        reject(error);
        return;
      }
      
      // 保存分享数据，以便wx.ready后使用
      lastShareData = shareData;
      
      // 如果已经配置过微信，只更新分享内容
      if (isWxConfigured && !forceRefresh) {
        console.log('微信已配置，只更新分享内容');
        configWxShareContent(shareData);
        resolve(true);
        return;
      }
      
      // 如果正在配置中，添加回调函数
      if (isWxConfiguring) {
        console.log('微信正在配置中，添加回调');
        wxReadyCallbacks.push(() => {
          configWxShareContent(shareData);
          resolve(true);
        });
        return;
      }
      
      // 标记为正在配置
      isWxConfiguring = true;
      
      // 获取微信配置
      let config;
      try {
        config = await getWxConfig(forceRefresh);
      } catch (error) {
        console.error('获取微信配置最终失败:', error);
        
        if (isWxConfigured) {
          // 如果之前已配置过，但获取新配置失败，使用已有配置
          console.log('获取新配置失败，使用已有配置');
          configWxShareContent(shareData);
          isWxConfiguring = false;
          resolve(true);
          return;
        }
        
        isWxConfiguring = false;
        reject(error);
        return;
      }

      // 重置配置状态
      isWxConfigured = false;

      // 微信配置
      console.log('开始wx.config配置');
      wx.config({
        debug: wxConfig.debug,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: wxConfig.jsApiList,
        openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app']
      });

      // 添加当前配置任务的回调
      const currentTaskShareData = shareData; // 捕获当前任务的shareData
      wxReadyCallbacks.push(() => {
        console.log('wx.ready callback: Configuring share content for link:', currentTaskShareData.link);
        configWxShareContent(currentTaskShareData); 
        resolve(true); // 解析initWxShare的Promise
      });

      wx.ready(() => {
        console.log('微信JS-SDK配置成功 (wx.ready) - 准备延时执行回调');
        isWxConfigured = true;
        isWxConfiguring = false;
        
        // 引入一个微小的延时
        setTimeout(() => {
          console.log('wx.ready: 开始执行 wxReadyCallbacks (延时后)');
          if (wxReadyCallbacks.length > 0) {
            // 执行所有等待的回调
            wxReadyCallbacks.forEach(callback => {
              try {
                callback();
              } catch (err) {
                console.error('wx.ready: 执行回调出错:', err);
              }
            });
            // 清空回调列表
            wxReadyCallbacks = [];
          } else {
            // 如果没有回调（理论上不应该，因为我们刚推进了一个），但wx.ready触发了
            // 尝试用最后一次的分享数据配置，作为一种备用措施
            if (lastShareData) {
              console.log('wx.ready: wxReadyCallbacks为空，尝试使用lastShareData配置分享');
              configWxShareContent(lastShareData);
            } else {
              console.warn('wx.ready: wxReadyCallbacks为空，且无lastShareData可用于配置分享');
            }
          }
        }, 300); // 尝试300毫秒的延时，可以根据测试结果调整
      });

      wx.error((res) => {
        console.error('微信配置失败:', res);
        isWxConfiguring = false;
        isWxConfigured = false;
        
        // 判断是否是URL不匹配问题（常见错误）
        const isUrlMismatch = res && res.errMsg && (
          res.errMsg.includes('invalid url domain') || 
          res.errMsg.includes('config:invalid signature')
        );
        
        if (isUrlMismatch) {
          console.log('检测到URL不匹配问题，尝试使用当前完整URL重新获取配置');
          // 使用完整URL（包含参数）重试
          const fullUrl = window.location.href.split('#')[0];
          currentSignUrl = fullUrl;
          
          setTimeout(() => {
            initWxShare(shareData, true)
              .then(result => resolve(result))
              .catch(error => reject(error));
          }, 500);
          return;
        }
        
        // 其他错误情况下，考虑重试
        if (retryCount < MAX_RETRY) {
          retryCount++;
          console.log(`微信配置失败，第${retryCount}次重试...`);
          setTimeout(() => {
            initWxShare(shareData, true)
              .then(result => resolve(result))
              .catch(error => reject(error));
          }, retryCount * 1000);
          return;
        }
        
        reject(new Error('微信配置失败: ' + (res.errMsg || JSON.stringify(res))));
      });
    } catch (error) {
      console.error('初始化微信分享失败:', error);
      isWxConfiguring = false;
      reject(error);
    }
  });
};

// 强制重新初始化微信分享
export const forceInitWxShare = async (shareData) => {
  console.log('强制重新初始化微信分享');
  isWxConfigured = false;
  isWxConfiguring = false;
  wxReadyCallbacks = [];
  retryCount = 0;
  return initWxShare(shareData, true);
};

// 更新微信分享内容
export const updateWxShare = async (shareData) => {
  return new Promise(async (resolve, reject) => {
    try {
      // 确保是在微信浏览器中
      if (!isWeixinBrowser()) {
        console.log('非微信浏览器，不更新分享');
        resolve(false);
        return;
      }
      
      // 如果微信还未配置，则完整初始化
      if (!isWxConfigured && !isWxConfiguring) {
        console.log('微信未配置，进行完整初始化');
        const result = await initWxShare(shareData);
        resolve(result);
        return;
      }
      
      // 如果正在配置中，添加回调
      if (isWxConfiguring) {
        console.log('微信正在配置中，添加更新回调');
        wxReadyCallbacks.push(() => {
          configWxShareContent(shareData);
          resolve(true);
        });
        return;
      }
      
      // 否则只更新分享内容
      console.log('微信已配置，只更新分享内容');
      configWxShareContent(shareData);
      resolve(true);
    } catch (error) {
      console.error('更新分享内容失败:', error);
      reject(error);
    }
  });
};

// 检查是否在微信浏览器中
export const isWeixinBrowser = () => {
  return /MicroMessenger/i.test(navigator.userAgent);
};

// 获取最后设置的分享数据
export const getLastShareData = () => {
  return lastShareData;
};

// 检查微信分享是否已经初始化
export const isWxShareInitialized = () => {
  return isWxConfigured;
}; 